import type { PermissionKey } from '../model/catalog';

/** Grants every key. */
export const WILDCARD_ALL = '*';

/** Whether the user may do `key`. */
export type PermissionChecker = (key: PermissionKey) => boolean;

/**
 * Build a checker over a granted list. A key is granted by an exact match,
 * by `*`, or by any ancestor wildcard: `orders.*` and `orders.detail.*` both
 * grant `orders.detail.view`. Anything else is denied (deny by default).
 */
export function createPermissionChecker(granted: readonly string[]): PermissionChecker {
  const set = new Set(granted);
  if (set.has(WILDCARD_ALL)) return () => true;
  return (key) => {
    if (set.has(key)) return true;
    const segments = key.split('.');
    for (let length = segments.length - 1; length > 0; length -= 1) {
      if (set.has(`${segments.slice(0, length).join('.')}.*`)) return true;
    }
    return false;
  };
}

/** Denies everything — used until the granted list has loaded. */
export const DENY_ALL: PermissionChecker = () => false;
